import React from "react";

import StatisticsCard from "../StatisticsCard";
import NavBarMenu from "../NavBarMenu";
import FooterMenu from "../FooterMenu";

import PieChartActiveUsers from "../graphs/pieChartActiveUsers";
import BarChartNotices from "../graphs/barChartNotices";
import BarChartUsers from "../graphs/barChartUsers";
import InstanceUserChange from "../graphs/instanceUserChange";
import InstanceNoticeChange from "../graphs/instanceNoticeChange";

import { Container } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export const updateInstanceHome = () => {
    window.home.updateData();
}

class home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refresh: false
        };
        window.home = this;
    }

    async updateData() {
       this.setState({ refresh: this.refresh = !this.refresh })
    }

    render() {
        return (
            <>
            <NavBarMenu/>
            <main key={this.state.refresh}>
                <Container fluid>            
                    <Row className="display-flex">
                        <Col fluid={"true"}>
                            <StatisticsCard data={{id: "activeUsers"}}/>
                        </Col>                 
                        <Col fluid={"true"}>
                            <StatisticsCard data={{id: "communicatedNotices"}}/>
                        </Col>
                        <Col fluid={"true"}>
                            <StatisticsCard data={{id: "totalInstances"}}/>
                        </Col>
                    </Row>
                    <Row className="display-flex">
                        <Col fluid={"true"} lg={8}>
                            <BarChartUsers/>
                        </Col>
                        <Col fluid={"true"} lg={4}>
                        <Tabs
                            defaultActiveKey="users"
                            id="instanceTab"
                            className="mb-3"
                        >
                            <Tab eventKey="users" title="Users">
                                <InstanceUserChange/>
                            </Tab>
                            <Tab eventKey="notices" title="Notices">
                                <InstanceNoticeChange/>
                            </Tab>
                        </Tabs>
                        </Col>
                    </Row>
                    <Row className="display-flex">
                        <Col fluid={"true"} lg={4}>
                            <PieChartActiveUsers/>
                        </Col>
                        <Col fluid={"true"} lg={8}>
                            <BarChartNotices/>
                        </Col>
                    </Row>
                </Container>
            </main>
            <FooterMenu />
        </>
        );
    }
}

export default home;